import { Lock } from "lucide-react";

// Official brand files go in /public/badges/. Set the filename once the official asset is added.
const LOGOS = {
  stripe: { src: "powered-by-stripe-blurple.svg", label: "Powered by Stripe badge", w: 96, href: "https://stripe.com" },
  visa: { src: null, label: "Visa logo", w: 36 },
  mastercard: { src: null, label: "Mastercard logo", w: 30 },
};

// Empty logo spots are only shown on preview/local — never on the live site.
const SHOW_PLACEHOLDERS = typeof window !== "undefined" && /preview\.emergentagent\.com|localhost/.test(window.location.hostname);

function Logo({ k, dark }) {
  const l = LOGOS[k];
  // The blurple Stripe badge is for light backgrounds only; the white version is pending for the dark footer.
  if (dark && k === "stripe") return null;
  if (l.src) {
    const img = <img src={`/badges/${l.src}`} alt={l.label.replace(/ (badge|logo)$/, "")} style={{ height: k === "stripe" ? 24 : 18, width: "auto", maxWidth: 120 }} data-testid={`trust-logo-${k}`} />;
    return l.href ? <a href={l.href} target="_blank" rel="noopener noreferrer" data-testid={`trust-logo-${k}-link`} className="transition-opacity hover:opacity-80">{img}</a> : img;
  }
  if (!SHOW_PLACEHOLDERS) return null;
  return (
    <span data-testid={`trust-logo-placeholder-${k}`} title={`Placeholder — official ${l.label} file needed`}
      className={`inline-flex h-[20px] items-center justify-center rounded border border-dashed px-1 text-[8px] font-semibold uppercase tracking-wide ${dark ? "border-white/40 text-white/60" : "border-slate-300 text-slate-400"}`}
      style={{ minWidth: l.w }}>
      {k === "stripe" ? "Stripe badge" : k}
    </span>
  );
}

export function PaymentLogos({ dark = false, className = "" }) {
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid="payment-logos">
      <Logo k="stripe" dark={dark} />
    </div>
  );
}

export default function PaymentTrust({ className = "", testid = "payment-trust" }) {
  return (
    <div className={`flex flex-col items-center gap-1.5 text-center ${className}`} data-testid={testid}>
      <p className="flex items-center gap-1 text-[11px] text-slate-500" data-testid={`${testid}-text`}>
        <Lock className="h-3 w-3 shrink-0" /> Secure payment — your money is held until you receive your item
      </p>
      <PaymentLogos />
    </div>
  );
}
